import { useMemo } from "react";
import { useDistrict } from "../lib/district-context";
import { KEVIA_TIERS, KEVIA_ACTIVE_TIER } from "../lib/kevia-identity";

const TIER_MAP = {
  plus:  KEVIA_TIERS.PLUS,
  basic: KEVIA_TIERS.BASIC,
  local: KEVIA_TIERS.LOCAL,
};

/**
 * useKeviaTier — dynamic tier resolved from the authenticated user profile.
 * Falls back to KEVIA_ACTIVE_TIER when profile is not yet loaded.
 *
 * Tier is stored as profiles.kevia_tier ('basic' | 'plus').
 * Admins are automatically assigned 'plus' via DB migration.
 */
export function useKeviaTier() {
  const { userProfile } = useDistrict();

  return useMemo(() => {
    const tierKey = userProfile?.kevia_tier ?? null;
    const tier    = TIER_MAP[tierKey] ?? KEVIA_ACTIVE_TIER;

    return {
      tier,
      isPlus:  tier.id === "plus",
      isBasic: tier.id === "basic",
      isLocal: tier.id === "local",
      label:   tier.label,
      badge:   tier.badge ?? null,
      can:     (capability) => tier.can?.[capability] ?? false,
    };
  }, [userProfile?.kevia_tier]);
}
